module.exports = __webpack_public_path__ + "static/media/structures-overview.34c97114.svg";